import { FC } from 'react';
import { WarningAlert } from 'components/Alerts';

export const PaymentMethodUpdateRequired: FC = () => (
  <WarningAlert my={4}>
    <WarningAlert.Heading>
      We do not currently have your credit card details on file and we are unable to complete your payment.
    </WarningAlert.Heading>
    <WarningAlert.Body>
      Due to an upgrade to our payment system, we require you to update your credit card details. To ensure your final payment is processed
      and your booking is secured, you will need to re-enter your payment details below for each booking.
    </WarningAlert.Body>
  </WarningAlert>
);
